import { Navigate } from 'react-router-dom'

export function RequireAuth({ children, navigationRoute }) {
  const token = localStorage.getItem('home-solutions-frontend')
  return token ? children : <Navigate to={navigationRoute} />
}
